
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'

export function VuseGoModel(props) {
  const vuse = useRef()
  const { nodes, materials } = useGLTF('/data/VuseGoPink.glb')

  useFrame(({clock}) => {
    vuse.current.rotation.y = clock.getElapsedTime()/3
  })

  return (
    <group ref={vuse} {...props} dispose={null}>
      <group position={[-0.207, 0.728, 0]} scale={[0.228, 0.385, 0.122]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005.geometry}
          material={materials.black}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_1.geometry}
          material={materials['blue matt']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_2.geometry}
        >
        <meshStandardMaterial 
          color={"#FE9DAF"} 
          metalness={0.8}
          roughness={0.6}
          side={THREE.DoubleSide}/>
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube005_3.geometry}
          material={materials.white}
        />
      </group>
    </group>
  )
}

// // useGLTF.preload('/data/VuseGoPink.glb')
